import Http from '@/services/http';
import {
  Lookup,
  ModuleRequest,
  IedRequestFilter,
  ModuleLookup,
  SensorLookup,
  SensorLookupRequest,
  ModuleTypes,
  ModulesByAssetsLookupRequest,
  ModulesByAssetsLookup,
  ModulesLinkedToAlarmRequest,
} from 'sigma-mappings';

const urls = {
  ieds: '/usuario/empresas/instalacoes/ativos/modulos',
  getModules: '/modulo/lookup',
  getModulesAlarms: '/modulo/alarme/lookup',
  getSensorsByAssets: '/ativo/sensores/lookup',
  getModulesByAssets: '/ativo/modulos/lookup',
};

export default {
  /**
   * Lista os modulos tendo como referencia todos ativos do usuario
   */
  getModules(options) {
    const apiModel = new IedRequestFilter(options);
    const http = new Http();
    return http
      .post(urls.ieds, apiModel)
      .then(({ data }) => data.map(item => new Lookup(item)));
  },
  getModulesLinkedToAlarms(assetsIds) {
    const http = new Http();
    const payload = new ModulesLinkedToAlarmRequest({ assetsIds });
    return http
      .post(urls.getModulesAlarms, payload)
      .then(({ data }) => data.map(item => new Lookup(item)));
  },
  getModulesByAssetId(assetId) {
    const http = new Http();
    const params = new ModuleRequest({
      assetId,
    });
    return http
      .get(urls.getModules, { params })
      .then(({ data }) => data.map(item => new ModuleLookup(item)));
  },
  getSensorsByAssetIds(params) {
    const http = new Http();
    const payload = new SensorLookupRequest(params);
    return http
      .post(urls.getSensorsByAssets, payload)
      .then(({ data }) => data.map(item => new SensorLookup(item)));
  },
  getModulesByAssetIds(params) {
    const http = new Http();
    const payload = new ModulesByAssetsLookupRequest({
      ...params,
      moduleTypes: [
        ModuleTypes.SUPERVISION,
        ModuleTypes.ENGINEERING,
        ModuleTypes.COMPONENT,
      ],
    });
    return http
      .post(urls.getModulesByAssets, payload)
      .then(({ data }) => data.map(item => new ModulesByAssetsLookup(item)));
  },
};
